import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { NavigationItem } from '../../../types';

@Component({
  selector: 'navigation-list-mobile',
  templateUrl: './navigation-list-mobile.component.html',
  styleUrls: ['./navigation-list-mobile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationListMobileComponent {
  @Input() items?: NavigationItem[];
}
